import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminDataWarehousePage } from '../../../../components/pages/backoffice/platform/platform-admin-data-warehouse-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/data-warehouse/')({
  component: () => (
    <PermissionChecker requiredPermissions={['session.access']}>
      <PlatformAdminDataWarehousePage />
    </PermissionChecker>
  ),
})
